/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalUserContentRecommendationResponseCollectionV3AllOfDataFromJSON, InternalUserContentRecommendationResponseCollectionV3AllOfDataToJSON, } from './InternalUserContentRecommendationResponseCollectionV3AllOfData';
import { CommonResponseCollectionPaginationFromJSON, CommonResponseCollectionPaginationToJSON, } from './CommonResponseCollectionPagination';
/**
 * Check if a given object implements the InternalUserContentRecommendationResponseCollectionV3 interface.
 */
export function instanceOfInternalUserContentRecommendationResponseCollectionV3(value) {
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
export function InternalUserContentRecommendationResponseCollectionV3FromJSON(json) {
    return InternalUserContentRecommendationResponseCollectionV3FromJSONTyped(json, false);
}
export function InternalUserContentRecommendationResponseCollectionV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pagination': CommonResponseCollectionPaginationFromJSON(json['pagination']),
        'data': (json['data'].map(InternalUserContentRecommendationResponseCollectionV3AllOfDataFromJSON)),
    };
}
export function InternalUserContentRecommendationResponseCollectionV3ToJSON(json) {
    return InternalUserContentRecommendationResponseCollectionV3ToJSONTyped(json, false);
}
export function InternalUserContentRecommendationResponseCollectionV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pagination': CommonResponseCollectionPaginationToJSON(value['pagination']),
        'data': (value['data'].map(InternalUserContentRecommendationResponseCollectionV3AllOfDataToJSON)),
    };
}
